export const genId = () => String(new Date().getTime());
